module.exports = __webpack_public_path__ + "img/galerie-32.bcc53612.jpg";